import React from 'react';
import IntlProvider from 'react-intl/lib/src/components/provider';


import { createTheme } from '@mui/material/styles';
import { SiteHeaderImage } from './siteHeaderImage';
import { SiteFooterImage } from './siteFooterImage';
import { LocaleContext } from '../../contexts/language';
import '@fontsource/open-sans/300.css';
import '@fontsource/open-sans'; // Defaults to weight 400
import '@fontsource/open-sans/500.css';
import '@fontsource/open-sans/600.css';
import '@fontsource/open-sans/700.css';
import ar from './ar.json';
import en from './en.json';

const languages = {
  ar,
  en
};
const DNMenuText = () => {
  const localeConfig = React.useContext(LocaleContext);

  return (
    <IntlProvider locale={localeConfig.lang} messages={languages[localeConfig?.lang] || languages.en}>
      {/*<Box sx={{pt:2}}>*/}
      {/*<Typography sx={{fontSize:14, mb:2 }} variant={"body1"}><FormattedMessage id={'dn.footer.menuText1'} defaultMessage={'The car buying comparison site.'}/></Typography>*/}
      {/*<Typography sx={{fontSize:14, mb:2 }} variant={"body1"}><FormattedMessage id={'dn.footer.menuText2'} defaultMessage={'Save money with the best new car deals across the UAE.'}/></Typography>*/}
      {/*</Box>*/}
    </IntlProvider>
  );
};
const primaryColor = '#F69E1F';
const primaryContrast = '#3a3a3c';

const secondaryColor = '#AA64A2';

const tertiaryColor = '#CF7650';

const leasingColor = secondaryColor;
// const leasingColorDarker = '#833078';

const purchaseColor = primaryColor;
const purchaseColorDarker = '#E08923';
// const white = '#fffff';

const usedColor = tertiaryColor;
// const usedColorDarker = '#894e35';
//
// const primaryBackground = '#fff';
// const secondaryBackground = '#f5f5f5';
// const tertiaryBackground = '#fdfdfd';
// const contrastBackground = '#f3f3f3';
// const contrastBorder = '#dfdfdf';


export const brandConfig = {
  SiteHeaderImage,
  SiteFooterImage,
  siteUrl: 'https://driveninja.com',
  finance: {
    financeRate: 2.5
  },
  hubspot: {
    portalId: '9252988',
    formContactForm:{
      en:'3a38dc6a-de10-4c6f-88db-ed12f4512690',
      ar:'3b11a3f1-f5f9-4102-8793-7fc76272b27a'
    },
    formFinanceADIBExistingCustomer: {
      en: 'e9cc2aec-af18-4361-a940-9be062140e15',
      ar: '981a6ffc-7eb8-4ebb-9a27-743c241cc56d'
    },
    formFinanceADIBNewCustomer: {
      en: 'd4809599-024f-49be-bce2-7dc6faf482bd',
      ar: '3c1c5f90-e081-4adb-9a9b-e0b308b22ad8'
    },
    formTestDriveBooking: {
      en: '75860caf-0c55-497c-a839-e0b2b019c175',
      ar: '75860caf-0c55-497c-a839-e0b2b019c175'
    },
    formMotorMerchantsCustomer: {
      en: '42f6fc1f-3ac5-4117-8a4f-ba65252fddd1',
      ar: '42f6fc1f-3ac5-4117-8a4f-ba65252fddd1'
    },
    formMotorMerchantsSubmit: {
      en: '111b8944-7077-4129-b198-bdd595affe38',
      ar: '111b8944-7077-4129-b198-bdd595affe38'
    }
  },
  appBarProps: {
    // color:'default'
  },
  social: {
    instagramPage: 'https://www.instagram.com/drive_ninja/',
    twitterPage: 'https://twitter.com/driveninja',
    facebookPage: 'https://www.facebook.com/driveninja'
  },
  layout: {
    header: {
      navBar: {
        brandTitle: 'Drive Ninja Home'
      }
    },
    footer: {
      footerMenu: {
        display:true,
        menuTextBlock: <DNMenuText />
      },
      newsletterBlock: {
        display: true,
        formId: 'e51fd1fc-83e7-4a9a-8c69-3d03ddfbbe77'
      },
      copyright: {
        brandName: { en: 'DriveNinja.com', ar: 'driveninja.com' },
        brandTitle: { en: 'Drive Ninja', ar: 'Drive Ninja' }
      }
    }
  },
  muiTheme: createTheme({
    custom: {
      components: {
        pageHeader: {
          background: 'linear-gradient(60deg, rgb(251, 142, 53) 0%, rgb(207, 118, 80) 35%, rgb(157, 65, 146) 100%);'

        },
        link: {
          color: primaryColor
        },
        modelOfferCard: {
          ads: {
            adTitleContainerColor: primaryColor
          },
          carLink: {
            color: '#fff'
          },
          CTImgInfo: {
            opacity: 0.8,
            color: primaryContrast,
            backgroundColor: '#3a3a3c',
            shadowColor: '#3a3a3c'
          },
          leasingAvailable: {
            color: '#3a3a3c',
            backgroundColor: leasingColor,
            svgColor: '#fff'
          },
          purchaseAvailable: {
            color: '#3a3a3c',
            backgroundColor: purchaseColor,
            svgColor: '#fff'
          },
          usedAvailable: {
            color: '#3a3a3c',
            backgroundColor: usedColor,
            svgColor: '#fff'
          },
          noOfferCol: {
            backgroundColor: '#CBCBCB8C',
            color: '#5d5c5c'
          },

          ribbon: {
            primaryBackgroundColor: primaryColor,
            secondaryBackgroundColor: purchaseColorDarker,
            color: '#FFF',
            boxShadowColor: '#3a3a3c'
          }

        },
        newsletterBlock: {
          backgroundColor: primaryColor,
          color: primaryContrast,
          buttonColorType: 'secondary'
        },
        copyrightBlock: {
          backgroundColor: '#4a4a4c',
          color: '#fff'
        },
        footerMenuBlock: {
          backgroundColor: primaryContrast,
          color: '#fff',
          linkHoverCcolor: primaryColor,
          logoHeight: '60px'
        },
        header: {
          backgroundColor: '#fff',
          color: '#3a3a3c'
        },
        inverseCard: {
          color: '#fff'
        }
      }
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            minHeight: 60,
            borderRadius: 15,
            // boxShadow:'0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 8px 8px 0px rgba(0,0,0,0.12)'
            // boxShadow:'0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 8px 8px 0px rgba(0,0,0,0.12)'
            boxShadow:'0px 0px 0px 0px rgba(0,0,0,0.2), 2px 2px 2px 0px rgba(0,0,0,0.14), 0px 8px 8px 0px rgba(0,0,0,0.12)',
            fontWeight:'600',
            textTransform: 'none',
          }
        }
      },
      MuiSelect: {
        styleOverrides: {
          root: {
            borderRadius: 15
          }
        }
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 15,
            boxShadow:'0px 0px 0px 0px rgba(0,0,0,0.2), 2px 2px 2px 0px rgba(0,0,0,0.14), 0px 8px 8px 0px rgba(0,0,0,0.12)'
          }
        }
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundColor: '#fff'
          }
        }
      },
      MuiAppBar: {
        styleOverrides: {

          colorPrimary: {
            backgroundColor: primaryColor,
            color: primaryContrast
          }
        }
      }
    },
    palette: {
      type: 'light',
      common: {
        black: '#3a3a3c',
        white: '#fffff'
      },
      appBar: {
        main: '#fff',
        contrastText: '#3a3a3c'
      },
      offerPricingCard: {
        currency: '#cbcbcb',
        title: '#3a3a3c',
        startsFrom: '#707070'
      },
      primary: {
        main: primaryColor,
        contrastText: '#ffffff'
      },
      secondary: {
        main: secondaryColor
      },
      tertiary: {
        main: '#3a3a3c'
      },
      background: {
        default: '#fffff',
        paper: '#fffff'
      }
    },
    typography: {
      fontFamily: 'Open Sans',
      h1: {
        fontSize: '2.8rem',
        fontWeight: 300
      },
      h2: {
        fontSize: '2.3rem'
      },
      h3: {
        fontSize: '2rem'
      },
      h4: {
        fontSize: '1.8rem',
        fontWeight: 600
      }
    }
  })

};
export default brandConfig;

